// import { Delete, Edit } from '@mui/icons-material';
import ModeEditOutlinedIcon from "@mui/icons-material/ModeEditOutlined";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import DragHandleOutlinedIcon from "@mui/icons-material/DragHandleOutlined";

import {
  Button,
  DialogActions,
  DialogContentText,
  Divider,
  TextField,
  Zoom,
} from "@mui/material";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardHeader from "@mui/material/CardHeader";
import Icon from "@mui/material/Icon";
import clsx from "clsx";
import { useEffect, useState } from "react";
import { connect } from "react-redux";

import { Grid } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import { getSingleMachine, updatemachinedocument } from "../actions/machines";

import {
  deleteGenericAttachment,
  GetSingleEquipmentType,
} from "../actions/objects";

import { makeStyles } from "tss-react/mui";
import DeletePopUp from "../components/DeletePopup";
import { config_UPTIME } from "../Constants";
import { canUserPerformAction } from "../shared-functions/userrights";
import { Theme247 } from "../styles/Theme247";
import axios, * as others from "axios";
import { docs_enum, getFileExtention } from "../utils/helpers";
import UploadAttachmentModal from "./UploadAttachmentModal";

const CardButton = (props) => {
  const [showButton, setShowButton] = useState(false);
  const [target, setTarget] = useState();
  /*
   * Styles
   */
  const useStyles = makeStyles()(() => ({
    cardButton: {
      "& .MuiCardHeader-subheader": {
        ...Theme247.typography.body2,
        fontSize: 14,
        color: Theme247.palette.grayShade["700"],
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      },
    },
    cardIcon: {
      // '& .mdi-icon, & .MuiSvgIcon-root': {
      //   width: props.size === "large" ? 48 : 24,
      //   height: props.size === "large" ? 48 : 24,
      // }
    },
  }));
  const { classes } = useStyles();

  const [fileid, setfileid] = useState();
  const [uploadUrl, setuploadUrl] = useState();
  const [bucketid, setbucketid] = useState();
  const [mainFile, setMainFile] = useState(props.file ? props.file : undefined);
  const [fileVersion, setFileVersion] = useState("");

  const [UploadDialogInternal, setUploadDialogInternal] = useState(false);
  const [fileidInternal, setfileidInternal] = useState();
  const [uploadUrlInternal, setuploadUrlInternal] = useState();
  const [bucketidInternal, setbucketidInternal] = useState();
  // const [NewfileInternal, setNewfileInternal] = useState()
  const [fileVersionInternal, setFileVersionInternal] = useState();

  const buttonCardHeader = (
    <>
      {/* <Tooltip title={props.title}> */}
      <CardHeader
        // avatar={
        //   props.icon ?
        //     <Icon color={props.iconcolor} className={classes.cardIcon}>
        //       {props.icon}
        //     </Icon>
        //     :
        //     false
        // }
        action={props.action}
        title={
          props.title.length > 20
            ? props.title.substring(0, 20) + "..."
            : props.title
        }
        subheader={props.subheader}
        onClick={() => {
          props.pdfUrl && window.open(props.pdfUrl, "PDF Viewer");
        }}
      />
      {/* </Tooltip> */}
    </>
  );
  const [openDialog, setopenDialog] = useState(false);

  const handleCloseDialog = () => {
    setopenDialog(false);
    setMainFile();
    settitle("");
    setdescription();
    setAttachmentEditMode(false);
  };
  const [title, settitle] = useState("");
  const [description, setdescription] = useState();

  const [attachmentCategory, setAttachmentCategory] = useState("");

  const [attachmentEditMode, setAttachmentEditMode] = useState(props.file ? true : false);

  const submitform = () => {
    const attachmentnodeid = props.nodeid;
    const lang = "de";
    if (mainFile != undefined) {
      const url = uploadUrl;
      const config = {
        headers: {
          "Content-Type": mainFile.type,
          "Access-Control-Allow-Origin": "*",
        },
      };
      const response = axios
        .put(url, mainFile, config)
        .then((res) => {
          //console.log(res.data)
        })
        .catch(function(error) {
          //console.log(error);
        });

      const file = {
        fileid: fileid,
        mimetype: mainFile.type,
        bucketid: bucketid,
        fileversion: fileVersion,
        nodeid: props.nodeid,
      };
      let _title = title === "" ? mainFile?.name?.split(".")[0] : title;
      props.updatemachinedocument({
        lang,
        title: _title,
        description,
        specifier: attachmentCategory,

        attachmentnodeid,
        file,
      });
    } else {
      props.updatemachinedocument({
        lang,
        title,
        specifier: attachmentCategory,
        description,
        attachmentnodeid,
      });
    }

    if (props.clientinfo == "machinebuilder") {
      props.GetSingleEquipmentType(props.machines[0]?.equipmenttype?.nodeid);
    } else {
      props.getSingleMachine(props.machines?.equipment?.nodeid);
    }

    handleCloseDialog();
  };

  const submitformInternal = () => {
    const attachmentnodeid = props.nodeid;
    const lang = "de";
    if (mainFile != undefined) {

      const url = uploadUrlInternal;
      const config = {
        headers: {
          "Content-Type": mainFile.type,
          "Access-Control-Allow-Origin": "*",
        },
      };
      const response = axios
        .put(url, mainFile, config)
        .then((res) => {
          //console.log(res.data)
        })
        .catch(function(error) {
          //console.log(error);
        });
      const file = {
        fileid: fileidInternal,
        mimetype: mainFile.type,
        bucketid: bucketidInternal,
        fileversion: fileVersionInternal,
        nodeid: props.nodeid,
      };
      let _title = title === "" ? mainFile?.name?.split(".")[0] : title;
      props.updatemachinedocument({
        lang,
        title: _title,
        description,
        specifier: attachmentCategory,
        attachmentnodeid,
        file,
      });
    } else {
      if (props.file) {
        props.updatemachinedocument({
          lang,
          title,
          description,
          specifier: attachmentCategory,
          file: props.file,
          attachmentnodeid,
        });
      } else {
        props.updatemachinedocument({
          lang,
          title,
          description,
          specifier: attachmentCategory,
          attachmentnodeid,
        });
      }
    }

    if (props.clientinfo == "machinebuilder") {
      props.GetSingleEquipmentType(props.machines[0]?.equipmenttype?.nodeid);
    } else {
      props.getSingleMachine(props.machines?.equipment?.nodeid);
    }

    handleCloseDialog();
  };

  const [openDialogDelete, setopenDialogDelete] = useState(false);

  const handleDialogDelete = () => {
    setopenDialogDelete(false);
  };

  const handleDelete = () => {
    const nodeid = props.nodeid;
    props.deleteGenericAttachment({ nodeid });
    if (props.clientinfo == "machinebuilder") {
      setTimeout(function() {
        props.GetSingleEquipmentType(props.machines[0]?.equipmenttype?.nodeid);
      }, 2000);
    } else {
      setTimeout(function() {
        props.getSingleMachine(props.machines?.equipment?.nodeid);
      }, 2000);
    }

    setopenDialogDelete(false);
  };

  const handleNewImage = (e) => {
    var file = e.target.files[0];
    if (e.target.files.length == 0) {
      return false;
    }
    const exstention = getFileExtention(e.target.files[0].type);

    const user_token = getItem("user");
    const url = config_UPTIME.url.API_URL + "/files";
    const method = "POST";
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + JSON.parse(user_token),
      },
    };
    const exstension_payload = [
      { nodeid: props.nodeid, extension: exstention, fileid: props.fileid },
    ];

    const response = axios
      .post(
        url,
        {
          count: 1,
          extensions: exstension_payload,
        },
        config
      )
      .then((res) => {
        var arr = [];
        setfileid(res.data[0].fileid);
        setuploadUrl(res.data[0].url);
        setbucketid(res.data[0].bucketid);
        setFileVersion(res.data[0].fileversion);
        setMainFile(file);
        return res;
      })
      .catch(function(error) {
        //console.log(error);
      });
    return response;
  };

  const handleNewImageInternal = (e) => {
    var file = e.target.files[0];
    if (e.target.files.length == 0) {
      return false;
    }
    const exstention = getFileExtention(e.target.files[0].type);

    const user_token = getItem("user");
    const url = config_UPTIME.url.API_URL + "/files";
    const method = "POST";
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + JSON.parse(user_token),
      },
    };
    const exstension_payload = [
      { nodeid: props.nodeid, extension: exstention, fileid: props.fileid },
    ];

    const response = axios
      .post(
        url,
        {
          count: 1,
          extensions: exstension_payload,
        },
        config
      )
      .then((res) => {
        var arr = [];
        setfileidInternal(res.data[0].fileid);
        setuploadUrlInternal(res.data[0].url);
        setbucketidInternal(res.data[0].bucketid);
        setFileVersionInternal(res.data[0].fileversion);
        setMainFile(file);
        return res;
      })
      .catch(function(error) {
        //console.log(error);
      });
    return response;
  };

  const customFileChange = (e) => {
    props.type == "manufacturer"
      ? handleNewImage(e)
      : handleNewImageInternal(e);
    setShowButton(true);
  };

  const handleFormSubmit = () => {
    props.type == "manufacturer" ? submitform() : submitformInternal();
  };

  const handleEdit = () => {
    if(props?.file){
      setMainFile(props.file)
    }
    settitle(props.title);
    setdescription(props.description);
    setAttachmentCategory(props?.attachmentCategory);
    setopenDialog(true);
    setAttachmentEditMode(true);
  };

  return (
    <>
      <Card
        className={clsx(classes.cardButton, "CardButton")}
        style={{
          border: 0,
          borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
          borderRadius: "0px",
          display: "flex",
          flexDirection: "row",
          textAlign: "center",
          alignItems: "center",
          marginBottom: "10px",
        }}
        variant="outlined"
      >
        <>
          <div className="attachmentWrapper">
            <div
              className="content"
              onClick={() => {
                props.pdfUrl && window.open(props.pdfUrl, "PDF Viewer");
              }}
            >
              <div className="attachmentHeader">

                {props.title.length > 80
                  ? props.title.substring(0, 80) + "..."
                  : props.title}{" "}
                <span
                  style={{ marginLeft: "2px" }}
                  className="attachmentSubHeader"
                >
                  {props?.fileMime}
                </span>
              </div>
              <div className="attachmentSubHeader">{props.description}</div>
            </div>
            <div className="actionButtons">
              <div>
                {canUserPerformAction(
                  props.profile?.features?.["equipment.attachment"],
                  "update"
                ) && (
                  <ModeEditOutlinedIcon
                    style={{
                      color: "#0E3F51",
                      display: props.nodeid != undefined ? "block" : "none",
                      cursor: "pointer",
                    }}
                    onClick={handleEdit}
                  />
                )}
              </div>
              <div>
                {canUserPerformAction(
                  props.profile?.features?.["equipment.attachment"],
                  "delete"
                ) && (
                  <DeleteForeverOutlinedIcon
                    style={{
                      color: "red",
                      display: props.nodeid != undefined ? "block" : "none",
                      cursor: "pointer",
                    }}
                    onClick={() => setopenDialogDelete(true)}
                  />
                )}
              </div>
              <div style={{ cursor: "pointer" }}>
                <DragHandleOutlinedIcon sx={{ color: "rgba(0, 0, 0, 0.5)" }} />
              </div>
            </div>
          </div>
        </>
      </Card>


      <UploadAttachmentModal
        hasTitle
        editMode
        hasDescription
        open={openDialog}
        onClose={handleCloseDialog}
        customFileChange={customFileChange}
        file={mainFile}
        setFile={setMainFile}
        handleSubmit={handleFormSubmit}
        description={description}
        setDescription={setdescription}
        title={title}
        setTitle={settitle}
        setTarget={setTarget}
        target={target}
        showButtn={showButton}
        setShowButton={setShowButton}
        setAttachmentCategory={setAttachmentCategory}
        attachmentCategory={attachmentCategory}
        fromDragAndDrop={props.fromDragAndDrop}
        attachmentEditMode={attachmentEditMode}
      />

      <DeletePopUp
        open={openDialogDelete}
        handleClose={handleDialogDelete}
        handleDelete={handleDelete}
        topic="Dokument"
      ></DeletePopUp>
    </>
  );
};

CardButton.defaultProps = {
  size: "standard",
  fullyclickable: true,
  icon: null,
  iconcolor: "primary",
  action: null,
  title: "Button Title",
  subheader: null,
  border: "",
};

export default connect(
  ({ isAuthUser, i18n, machines, clientinfo, profile }) => ({
    isAuthUser,
    i18n,
    machines,
    clientinfo,
    profile,
  }),
  {
    updatemachinedocument,
    getSingleMachine,
    deleteGenericAttachment,
    GetSingleEquipmentType,
  }
)(CardButton);
